module.exports = __webpack_public_path__ + "static/media/Vector.89fff574.svg";